import './FlashErrorMessage.scss';

import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import { useScanSelfServiceAutosuggestionsContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';

const TIMEOUT = 5000;

const FlashErrorMessage = ({ className, searchValue }) => {
  const { searchPending } = useScanSelfServiceContext();
  const { errorMessageKey } = useScanSelfServiceAutosuggestionsContext();
  const { t } = useTranslation();
  const timeoutIdRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [messageKey, setMessageKey] = useState(null);

  useEffect(() => {
    if (errorMessageKey !== null) {
      setIsOpen(true);
      setMessageKey(errorMessageKey);
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        setMessageKey(null);
        setIsOpen(false);
      }, TIMEOUT);
    }
  }, [errorMessageKey]);

  useEffect(() => {
    if (searchPending) {
      setMessageKey(null);
      clearTimeout(timeoutIdRef.current);
      setIsOpen(false);
    }
  }, [searchPending]);

  useEffect(
    () => () => {
      setMessageKey(null);
      clearTimeout(timeoutIdRef.current);
    },
    [],
  );

  return (
    <div
      className={cn(
        'flash-error-message',
        {
          'flash-error-message--open': isOpen,
        },
        className,
      )}
    >
      {isOpen ? t(messageKey, { term: searchValue }) : <>&nbsp;</>}
    </div>
  );
};

FlashErrorMessage.defaultProps = {
  ...ClassNameDefaultProps,
  searchValue: '',
};

FlashErrorMessage.propTypes = {
  ...ClassNamePropTypes,
  searchValue: PropTypes.string,
};

export default FlashErrorMessage;
